import { useQueryClient } from '@tanstack/react-query';
import keys from './keys';
import useApiMutation from '../useApiMutation';

const useSetDeezer = () => {
  const queryClient = useQueryClient();

  const enableDeezer = useApiMutation({
    getRequestUrl: ({ showId } = {}) => `/shows/${showId}/deezer`,
    method: 'POST',
    onSuccess: (newShowData) => {
      queryClient.setQueryData(keys(newShowData.showId).show, newShowData);
    },
  });

  return {
    enableDeezer: enableDeezer.mutate,
    isEnableDeezerLoading: enableDeezer.isLoading,
    isEnableDeezerError: enableDeezer.isError,
    isEnableDeezerSuccess: enableDeezer.isSuccess,
    enableDeezerInfo: { ...enableDeezer },
  };
};

export default useSetDeezer;
